import { Controller } from "@hotwired/stimulus"

// On connect, horizontally scrolls the controller's element so the inner
// "active" descendant sits centered (or as close to center as the row's
// edges allow). Used by the arena tab nav so the current section is
// always in view on small screens, even when it sits past the fold of
// the horizontal scroller.
//
// Manipulates only `scrollLeft` on the scroll container — never calls
// scrollIntoView — so it can't accidentally scroll the page vertically
// when the nav is below the fold on first load.
export default class extends Controller {
  static values = {
    selector: { type: String, default: '[aria-selected="true"]' }
  }

  declare selectorValue: string

  connect() {
    // Defer one frame so layout is settled (fonts/icons may still be
    // sizing on first paint, which would give us stale offsets).
    requestAnimationFrame(() => this.center())
  }

  private center() {
    const scroller = this.element as HTMLElement
    const active = scroller.querySelector<HTMLElement>(this.selectorValue)
    if (!active) return

    const target = active.offsetLeft + active.offsetWidth / 2 - scroller.clientWidth / 2
    const max = scroller.scrollWidth - scroller.clientWidth
    scroller.scrollLeft = Math.max(0, Math.min(target, max))
  }
}
